/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/intro-employees.html";

import LanguageManager from "Sources/services/language-manager";
const infoIcons = require.context("!raw-loader!Images/info", false, /\.svg$/);

require("Styles/components/popup/intro-employees.scss");

class IntroEmployeesView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        let keyPrefix = "intro." + options.tutorialName + ".";

        let title = LanguageManager.getValueForKey(keyPrefix + "title");
        let description = LanguageManager.getValueForKey(keyPrefix + "description");

        options.html.find(".popup-subtitle").html(title);
        options.html.find(".popup-message").html(description);

        this.event = options.event;

        if (options.tutorialName === "employees-1")
        {
            options.html.find(".popup-image").html(infoIcons("./assign_employees.svg"));
        }
    }
}

module.exports = IntroEmployeesView;



// WEBPACK FOOTER //
// ./app/js/components/popup/intro-employees.js